// extracted by mini-css-extract-plugin
export var initials = "MenuUser-module--initials--1Mm7D";
export var icon = "MenuUser-module--icon--2axZA";